
















import Vue from 'vue'
import TaskTable from '../components/CrawlerTaskTable.vue'
import { Scheduler, scheduler } from '@rhitics/core'

const acceptCategories = ['Crawler']

export default Vue.extend({
  name: 'ScheduleTaskPage',
  components: {
    TaskTable
  },
  data() {
    return {
      loading: false,
      tasks: [] as Scheduler.Task[],
      specs: [] as Scheduler.Spec[],
      categories: [] as Scheduler.Category[]
    }
  },
  async mounted() {
    await this.updateTaskTable()
    await this.updateSpecTable()
    await this.updateCatergoryTable()
  },
  methods: {
    async updateTaskTable() {
      this.loading = true
      this.tasks = (await scheduler.task.list()).data
        .filter(task => acceptCategories.includes(task.spec?.category?.name!))
        .map(task => {
          task.excludeDays = []
          task.payload = JSON.parse(task.payload as string)
          task.headers = JSON.parse(task.headers as string)
          task.spec.schema = JSON.parse(task.spec.schema as string)
          task.spec.headersSchema = JSON.parse(task.spec.headersSchema as string)
          return task
        })
      this.loading = false
    },
    async updateSpecTable() {
      this.specs = (await scheduler.spec.list()).data
        .map(spec => {
          spec.schema = JSON.parse(spec.schema as string)
          spec.headersSchema = JSON.parse(spec.headersSchema as string)
          return spec
        })
        .filter(spec => acceptCategories.includes(spec.category?.name!))
    },
    async updateCatergoryTable() {
      this.categories = (await scheduler.category.list()).data.filter(catergory =>
        acceptCategories.includes(catergory.name)
      )
    }
  }
})
